import { Component, inject, input, computed } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nService } from '../../../services/i18n.service';
import { UiService } from '../../../services/ui.service';
import { IHtstInfoField } from '../../../models/sensoradditionalfield.model';
import { GLOBAL_CONSTANT } from '../../../constants/global.constant';
import { I18N_KEYS } from '../../../enums/i18.enum';

@Component({
  selector: 'app-htst-info-data',
  imports: [NzIconModule],
  templateUrl: './htst-info.html',
  styleUrls: ['./htst-info.scss'],
})
export class HtstInfoDataComponent {
  //Inputs using Angular Signals
  htstInfo = input<IHtstInfoField | null>(null); // HTST info object
  sensorType = input<string>(GLOBAL_CONSTANT.EMPTY_STRING); // Sensor type label

  // Inject services
  public i18n = inject(I18nService);
  private ui = inject(UiService);

  isMobile = computed(() => this.ui.IsMobile());

  formattedInfo = computed(() => {
    const info = this.htstInfo();
    if (!info) return [];

    return [
      { label: this.i18n.langString(I18N_KEYS.GATEWAY_HTST), value: info.gatewayId ?? '-' },
      { label: this.i18n.langString(I18N_KEYS.MAC_ADDRESS), value: info.macAddress ?? '-' },
      { label: this.i18n.langString(I18N_KEYS.DAU_MODEL), value: info.dauModel ?? '-' },
      { label: this.i18n.langString(I18N_KEYS.SENSOR_COLOR), value: info.sensorColor ?? '-' },
    ];
  });
}
